// extracted by mini-css-extract-plugin
export default {"basic-layout":"BasicLayout_basic-layout__8xfmd"};